<script>
import ActionBar from '@/components/core/ActionBar.vue';

export default {
  extends: ActionBar,
  data() {
    return {
      resourceName: 'Site',
      urlFragment: 'sites',
    };
  },
};
</script>

<style></style>
